import {Entity} from '@s-ui/domain'

export class ConversationUserEntity extends Entity {
  /**
   * @constructor
   * @param {String} conversationId
   */
}
